import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { verifyUser } from "../../../slices/auth/login/action";
import { useDispatch } from "react-redux";

const UserVerify = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // 'verifying', 'success', 'failed'
  const [message, setMessage] = useState("");
  useEffect(() => {
    // Extract AuthKey from URL
    const authKey = searchParams.get("AuthKey");
    const type = searchParams.get("type");
    if (authKey) {
      verifySponsorUser(authKey, type);
    } else {
      setStatus("failed");
      setMessage("Invalid or missing verification key.");
    }
  }, [searchParams]);

  const verifySponsorUser = async (authKey, type) => {
    try {
      const response = await dispatch(
        verifyUser({ input: { hashToken: authKey, type } })
      );
      if (response?.status && response?.status === "success") {
        setStatus("success");
        setMessage(
          response.message || "Your account has been successfully verified!"
        );
      } else {
        setStatus("failed");
        setMessage(
          response.message || "Verification failed. Please try again."
        );
      }
    } catch (error) {
      setStatus("failed");
      setMessage(
        "An error occurred during verification. Please try again later."
      );
    }
  };

  return (
    <div className="p-5 text-center">
      {status === "verifying" && (
        <>
          <h1>Verifying...</h1>
          <p>Please wait while we verify your account.</p>
        </>
      )}
      {status === "success" && (
        <>
          <h1>Verification Successful!</h1>
          <p>{message}</p>
          <Link to="/login" className="btn btn-success">
            Go to Login
          </Link>
        </>
      )}
      {status === "failed" && (
        <>
          <h1>Verification Failed</h1>
          <p>{message}</p>
          <Link to="/resend-verification" className="btn btn-warning">
            Resend Verification Email
          </Link>
        </>
      )}
    </div>
  );
};

export default UserVerify;
